import 'jquery';

(function ($) {
  let body = $('body');

  body.on('keydown', function (event) {
    if (event.key === 'Tab' || event.keyCode === 9) {
      body.addClass('tabbing');
    }
  });

}(jQuery));
